
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  @Component({
    computed: {
      ...mapGetters([
        'isLoading',
        'isLinkingCallbackLoading'
      ])
    }
  })
  export default class Header extends Vue {
    data() {
      return {
        frontUrl: '',
        headerImage: '',
        headerTitle: '',
      }
    }

    created() {
      this.$data.frontUrl = this.$data.RCEnvironment.VUE_APP_FRONT_URL;
      this.setHeaderSettings();
    }

    private setHeaderSettings(): void {
      let headerImage = '';
      let headerTitle = '';

      if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'TWO-POINT-STUDIOS') {
        headerImage = "tps/header-icon.png";
        headerTitle = "Two Point County Header Icon";
      } else if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'CREATIVE-ASSEMBLY') {
        headerImage = "ca/header-icon.png";
        headerTitle = "Creative Assembly Header Icon";
      } else if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'SANDBOX') {
        headerImage = "sandbox/header-icon.png";
        headerTitle = "Sandbox Header Icon";
      } else if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'FOCUS') {
        headerImage = "focus/header-icon.png";
        headerTitle = "Focus Header Icon";
      } else if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'AVALANCHE') {
        headerImage = "avlc/header-icon.svg";
        headerTitle = "Avalanche Header Icon";
      } else if (["LOCAL", "STAGING", "TEST", "PROD"].includes(this.$data.RCEnvironment.VUE_APP_ENVIRONMENT)) {
        headerImage = "Logo-Amplifiers-Account.svg";
        headerTitle = "Amplitude Header Icon";
      }

      headerImage = require('@/assets/images/' + headerImage);
      this.$set(this.$data, "headerImage", headerImage);
      this.$set(this.$data, "headerTitle", headerTitle);
    }
  }
